// Copyright 2025, Imprivata, Inc.  All rights reserved.

import type { CodingContext } from '@imprivata-cloud/dataprivacy';
import { useMutation } from '@tanstack/react-query';

import { changeImprIdpUserPassword } from '../../api/selfServiceServices';
import type { UserPasswordChangeRequest } from '../../api/types';

export type ChangePassword = {
  changePasswordRequest: UserPasswordChangeRequest;
  codingContext?: CodingContext;
};

export const useChangePassword = () => {
  return useMutation<void, Error, ChangePassword>({
    mutationFn: (data: ChangePassword) => changeImprIdpUserPassword(data.changePasswordRequest, data.codingContext),
  });
};
